import { FC } from 'react';

import { Box, Button, Card } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';

import SearchBar from '@src/main/ui/components/Search/SearchBar';
import { useSearch } from '@src/main/ui/components/Search/hooks/useSearch';
import styles from './ManageUsers.module.scss';

const ManageUsers: FC = () => {
  const { user, addAdminRole } = useUserContext();
  const { filtederUsersResults } = useSearch();
  return (
    <>
      <Typography variant="h3" sx={{ paddingRight: '40px', marginBottom: '16px' }}>
        Manage Admin Users
      </Typography>

      <SearchBar placeholder="Which users are you looking for?" />

      {filtederUsersResults && filtederUsersResults?.length > 1 ? (
        <Box className={styles.container}>
          <Card className={styles.container__card}>
            {filtederUsersResults
              .filter((userFromList) => userFromList.name !== user?.name)
              .map((userFromList) => (
                <Box key={userFromList.id} className={styles.container__item}>
                  <Typography variant="body1">{userFromList.name}</Typography>
                  <Box className={styles.container__actions}>
                    <Button
                      type="button"
                      color="secondary"
                      variant="contained"
                      style={{ width: '90px' }}
                      onClick={() => addAdminRole(userFromList.id, userFromList)}
                    >
                      {userFromList.roles.includes('ADMIN') ? 'Remove' : 'Add'}
                    </Button>
                  </Box>
                </Box>
              ))}
          </Card>
        </Box>
      ) : (
        <Typography variant="h5" sx={{ marginTop: '30px', textAlign: 'center' }}>
          No users found
        </Typography>
      )}
    </>
  );
};

export default ManageUsers;
